import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/shared/api.service';
import { HazardModel } from 'src/app/models/hazard.model';
import { ApiResponseModel } from 'src/app/models/api-response.model';
import { UtilsService } from 'src/app/shared/utils.service';
import { RISK_LEVEL_OF_CONTROLS } from 'src/app/shared/risk-level-of-controls';
import {UserPublicProfileComponent} from "../../shared/user-public-profile/user-public-profile.component";
import { AssetsViewComponent } from '../../assets/assets-view/assets-view.component';

@Component({
  selector: 'app-sites-hazards-view',
  templateUrl: './sites-hazards-view.component.html',
  styleUrls: ['./sites-hazards-view.component.scss']
})
export class SitesHazardsViewComponent implements OnInit {
  hazard: HazardModel = new HazardModel();
  loc_list = RISK_LEVEL_OF_CONTROLS;
  hide_asset_link: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { id: number; hide_asset_link?: boolean },
    private api: ApiService,
    public utils: UtilsService
  ) {}

  ngOnInit() {
    this.hide_asset_link = this.data.hide_asset_link ?? false;
    this.api
      .laravelApiObservable('get', `hazards/${this.data.id}`)
      .subscribe(
        (response: ApiResponseModel<HazardModel>) =>
          (this.hazard = response.data)
      );
  }

  /**
   * Open the asset view dialog for a related asset.
   *
   * @param {number} asset_id - The id of the asset to view.
   * @return {void}
   */
  onViewAsset(asset_id: number): void {
    this.utils.showComponentDialog(
      AssetsViewComponent,
      { asset_id: asset_id },
      { width: '90%' }
    );
  }

  onUserPublicView(hash: string) {
    this.utils.showComponentDialog(
      UserPublicProfileComponent,
      hash,
      { width: '90%' },
      () => {
        // Refresh the list regardless of how the dialog is closed.
      }
    );
  }
}
